import AutomateIcon from '../../icons/automate.svg'
import ChatsIcon from '../../icons/chats.svg'
import EmailIcon from '../../icons/email.svg'
import ServiceRequestIcon from '../../icons/service-request.svg'

export const LABEL_DEFAULT_SIZE = 24

export const LABEL_SIZE_20 = 20

export const LABEL_COMPACT_SIZE = 4

export const LABEL_QA_CONTEXT = 'chip'

export const LABEL_TEXT_COLOR = 'var(--color-white)'

export const LABEL_ICON_COLOR = 'var(--color-white)'

export const LABEL_ENTITY_VALUE = {
  automation: 'automation',
  chat: 'chat',
  email: 'email',
  request: 'request',
}

export const LABEL_ENTITY_META = [
  {
    Icon: ServiceRequestIcon,
    labelKey: 'Label.EntityOptionRequestKey',
    value: LABEL_ENTITY_VALUE.request,
  },
  {
    Icon: ChatsIcon,
    labelKey: 'Label.EntityOptionChatKey',
    value: LABEL_ENTITY_VALUE.chat,
  },
  {
    Icon: AutomateIcon,
    labelKey: 'Label.EntityOptionAutomationKey',
    value: LABEL_ENTITY_VALUE.automation,
  },
  {
    Icon: EmailIcon,
    labelKey: 'Label.EntityOptionEmailKey',
    value: LABEL_ENTITY_VALUE.email,
  },
]

export const LABEL_PRIVACY_VALUE_PRIVATE = 'private'

export const LABEL_PRIVACY_VALUE_PUBLIC = 'public'
